import React, { useState } from 'react';
import { Box, Typography, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import { uniq } from 'lodash';

const FilterCheckbox = ({ name, values, prevValue, label, onHandleChange }) => {
    return (
        <Box>
            <Box mb={1}>
                <Typography variant="body2">{label}</Typography>
            </Box>
            <Box display="flex" flexDirection="column">
                {values.map((value, index) => (
                    <CheckboxItem key={index} prevValue={prevValue} value={value} name={name} onHandleChange={onHandleChange} />
                ))}
            </Box>
        </Box>
    );
};

const CheckboxItem = ({ value, prevValue, name, onHandleChange }) => {
    const classes = useStyles();
    const [checked, setChecked] = useState(false);

    const handleChange = event => {
        setChecked(event.target.checked);
        onHandleChange(name, event.target.checked ? uniq([...prevValue, value]) : prevValue.filter(v => v !== value), 'checkbox');
    };

    return (
        <FormControlLabel
            control={<Checkbox checked={checked} onChange={handleChange} name={name} className={classes.checkbox} />}
            label={value}
            className={classes.formLabel}
        />
    );
};

const useStyles = makeStyles(theme => ({
    formLabel: {
        marginLeft: -5,
    },
    checkbox: {
        padding: 4,
        paddingRight: 9,
    },
}));

export default FilterCheckbox;
